import jwt_decode from "jwt-decode";
import { ls } from "../localStorage";
import CryptoJS from 'crypto-js';

export const toggleFullSceen = (type: string) => {
    console.log('toggleFullSceen');
    let doc: any = document;
    let docEl: any = document.documentElement;
    let requestFullScreen = docEl.requestFullscreen || docEl.webkitRequestFullscreen || docEl.webkitEnterFullScreen ||
      docEl.mozRequestFullscreen || docEl.msRequestFullscreen;
    let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen || doc.msExitFullscreen;
    let fullScreen = doc.fullscreenElement || doc.mozFullScreenElement ||
      doc.webkitFullscreenElement || doc.msFullscreenElement;
    if (requestFullScreen == undefined)
      return
    if (!fullScreen && type === 'fullScreen') {
      requestFullScreen.call(docEl);
    }
    else {
      if (fullScreen && cancelFullScreen)
        cancelFullScreen.call(doc);
    }
  }

export const isTokenValid=(token:string|any)=>{
    try {
        if(ls.isValid(token))
        {
            let decode_token:any =jwt_decode(token)
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            return (decode_token.exp < currentTimeSeconds)?false:true;   
        }
        else
        {
            return false;
        }
    } catch (error) {
        return false;
    }
}

/**
 * WHO a session belongs to. Here rather than in a screen so every screen asks the same question the
 * same way.
 *
 * The values mirror play-service's JOBS enum (src/guards/jobs.ts) EXACTLY, including `superUser`
 * being the string 'admin'. A screen that invented its own spelling would disagree with the guard
 * that answers its calls, and the disagreement would show up as a 403 rather than as a wrong screen.
 */
export enum ROLE {
    student = 'student',
    parent = 'parent',
    teacher = 'teacher',
    siteAdmin = 'siteAdmin',
    groupAdmin = 'groupAdmin',
    mathBuddyAdmin = 'mathBuddyAdmin',
    superUser = 'admin',
}

/**
 * The roles a session carries - BOTH claims, because that is what the service reads: JobsGuard builds
 * a user's jobs from `role` AND `role_base`, so a site admin whose `role` says 'teacher' is still a
 * site admin. These come off the `currentUser` a screen is launched with.
 */
export const rolesOf = (user: any): string[] =>
    [user?.role, user?.role_base].map((r) => String(r || '')).filter(Boolean);

/** Does this session carry this role? Every check below is this one question. */
export const hasRole = (user: any, role: ROLE): boolean =>
    rolesOf(user).includes(role);

/** Any one of them - for a screen open to several roles. */
export const hasAnyRole = (user: any, roles: ROLE[]): boolean =>
    roles.some((role) => hasRole(user, role));

export const isStudent = (user: any): boolean => hasRole(user, ROLE.student);
export const isParent = (user: any): boolean => hasRole(user, ROLE.parent);
export const isTeacher = (user: any): boolean => hasRole(user, ROLE.teacher);
export const isSiteAdmin = (user: any): boolean => hasRole(user, ROLE.siteAdmin);
export const isGroupAdmin = (user: any): boolean => hasRole(user, ROLE.groupAdmin);
export const isMathBuddyAdmin = (user: any): boolean => hasRole(user, ROLE.mathBuddyAdmin);
export const isSuperUser = (user: any): boolean => hasRole(user, ROLE.superUser);

/** Everyone who reaches a play screen through a teacher's session rather than a student's. */
export const STAFF_ROLES: ROLE[] = [
    ROLE.teacher,
    ROLE.siteAdmin,
    ROLE.groupAdmin,
    ROLE.mathBuddyAdmin,
    ROLE.superUser,
];

/**
 * Staff, and NOT a student as well. Asked this way round on purpose: it is what decides whether a
 * screen may only read, so a session carrying no role at all answers false and keeps whatever a
 * student would get - a missing field must not take a student's quiz away from them.
 */
export const isStaffOnly = (user: any): boolean =>
    !isStudent(user) && hasAnyRole(user, STAFF_ROLES);

export const getTimeSpent = (startTime:any) => {
    const endTime = new Date()
    return Math.round(((endTime.getTime() - startTime.getTime()) / 1000) + 0.5);
  }
  
export const isTV=()=>{
    let regexp = /tv|jiopages/i;
    return regexp.test(navigator.userAgent.toLowerCase());
} 

export const isMobileDevice=()=>{
    let regexp = /android|iphone|kindle|ipad/i;
    return regexp.test(navigator.userAgent.toLowerCase());
} 

export const isFlatPanel = () => {
    let regexp = /SMART-TV|Tizen|WebOS|BRAVIA|Viera/i;
    return regexp.test(navigator.userAgent.toLowerCase());
}
  
export const encryptData = (data: {}) => {
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || '';
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    return encrypted;
  }

export const decryptData = (encrypted:string) => {
    const SECRET_KEY=process.env.REACT_APP_SECRET_KEY || '';
    const decrypted = CryptoJS.AES.decrypt(encrypted, SECRET_KEY).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }